<template>
	<el-container id="test" v-loading="test_load">
		<div class="location" v-if="temp.location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in location" :key="index" v-if="item.show" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
		<div class="testCon" v-loading="jiaojuandianji">
			<div class="test_tit">
				<h1 class="titCon">{{test_tit}}</h1>
				<div class="count">
					<p class="time">本次考试限时{{test_time}}分钟，共{{test_exam}}道题，满分为{{test_fen}}分</p>
				</div>
			</div>
			<el-form :model="testForm">
				<div class="big_question" v-for="(item,index) in formal" :key="index" v-if="item.list && item.list.length >= 1">
					<div class="big_qs_tit">
						<font class="qiZh">{{$selfjs.qiZh(index+1)}}、</font>
						<font class="headline">{{item.headline == "" ? big_qs_tit_txt(key) : item.headline}}</font>
						<font class="big_qs_count">（共{{item.list.length}}题）</font>
					</div>
					<ul :class="item.type" v-if="item.type=='single'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img">
								<img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<el-form-item v-if="testForm[index].length>0" v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index">
									<el-radio-group @input="forceUpdate" v-model="testForm[index][ti_index].answer[0]">
										<el-radio :label="chObj.flag">
											<!-- {{chObj.flag+'. '+chObj.content}} -->
											{{chObj.flag}}.
											<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
											 {{chObj.content}}
										</el-radio>
									</el-radio-group>
								</el-form-item>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='multiple'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<el-form-item>
									<el-checkbox-group @input="forceUpdate" v-if="testForm[index].length>0" v-model="testForm[index][ti_index].answer">
										<el-checkbox v-for="(chObj,ch_index) in tiObj.choices" :key="ch_index" :label="chObj.flag" :name="'ch_index'+ch_index">
											<!-- {{chObj.flag+'. '+chObj.content}} -->
											{{chObj.flag}}.
											<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
											{{chObj.content}}
										</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='judgement'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<el-form-item>
									<el-radio-group @input="forceUpdate" v-if="testForm[index].length>0" v-model="testForm[index][ti_index].answer[0]">
										<el-radio label="对"></el-radio>
										<el-radio label="错"></el-radio>
									</el-radio-group>
								</el-form-item>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='fill' || item.type=='other1' || item.type=='other2'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<!-- 输入框显示 -->
								<div class="input_box">
									<el-form-item :style="item.type!='fill'?'width: 100%;':''"  v-for="ch_index in tiObj.fill_count" :key="ch_index" v-if="testForm[index].length>0">
										<el-input @input="forceUpdate" :type="item.type!='fill'?'textarea':'text'" v-model="testForm[index][ti_index].answer[ch_index-1]" autocomplete="off"></el-input>
									</el-form-item>
								</div>
								<!-- 图片选择 -->
								<div class="upload_box">
									<el-upload v-if="testForm[index].length>0" class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
									:on-change="handle_change"
									:on-exceed="handle_exceed"
									:file-list="testForm[index][ti_index].answer_img">
										<i slot="default" @click="handProgress(index, ti_index)" class="el-icon-plus"></i>
										<div slot="file" slot-scope="{file}">
											<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
											<div class="el-upload-list__item-actions">
												<span @click="handlePictureCardPreview(file)">
													<i class="el-icon-zoom-in"></i>
												</span>
												<span @click="handleRemove(file, index, ti_index)">
													<i class="el-icon-delete"></i>
												</span>
											</div>
										</div>
									</el-upload>
									<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
								</div>
							</dl>
						</li>
					</ul>
					<ul :class="item.type" v-if="item.type=='open'">
						<li :class="item.type+index+ti_index" v-for="(tiObj,ti_index) in item.list" :key="ti_index">
							<p><font>{{(ti_index+1)}}.</font><span class="title" v-html="tiObj.title.replace(/\n/g, '<br>')"></span><span class="score">（{{tiObj.score}}分）</span></p>
							<p v-if="tiObj.question_img" class="question_img"><img :src="ali_oss+tiObj.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+tiObj.question_img})"></p>
							<dl>
								<div class="input_box">
									<el-form-item v-for="ch_index in tiObj.fill_count" :key="ch_index" v-if="testForm[index].length>0">
										<el-input @input="forceUpdate" type="textarea" class="open_textarea" v-model="testForm[index][ti_index].answer[0]" autocomplete="off"></el-input>
									</el-form-item>
								</div>
								<!-- 图片选择 -->
								<div class="upload_box" v-if="temp.open.up_img">
									<el-upload v-if="testForm[index].length>0" class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
									:on-change="handle_change"
									:on-exceed="handle_exceed"
									:file-list="testForm[index][ti_index].answer_img">
										<i slot="default" @click="handProgress(index, ti_index)" class="el-icon-plus"></i>
										<div slot="file" slot-scope="{file}">
											<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
											<div class="el-upload-list__item-actions">
												<span @click="handlePictureCardPreview(file)">
													<i class="el-icon-zoom-in"></i>
												</span>
												<span @click="handleRemove(file, index, ti_index)">
													<i class="el-icon-delete"></i>
												</span>
											</div>
										</div>
									</el-upload>
									<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
								</div>
							</dl>
						</li>
					</ul>
					<div v-if="item.type=='universal'" v-for="(universal_item,universal_index) in item.list" :key="universal_index+'sub'+index">
						<!-- <div class="big_qs_tit" v-if="index == 0">
							<font class="headline">{{formal.universal.headline == "" ? big_qs_tit_txt('universal') : formal.universal.headline}}</font>
						</div> -->
						<div class="universal_item_headline">{{universal_item.headline}}</div>
						<div class="universal_item_title" v-html="universal_item.title"></div>
						<div v-for="(children_item,sub_i) in universal_item.children" :key="children_item.id+'sub'+sub_i">
							<ul :class="children_item.type" v-if="children_item.type=='single'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<!-- {{children_item.unive_i}}
										{{testForm_universal[children_item.unive_i]}}
										{{children_item.id}} -->
										<el-form-item v-for="(chObj,ch_index) in children_item.choices" :key="ch_index">
											<el-radio-group @input="forceUpdate" v-model="testForm_universal[children_item.unive_i][children_item.id].answer[0]">
												<el-radio :label="chObj.flag">
													{{chObj.flag}}.
													<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
													 {{chObj.content}}
												</el-radio>
											</el-radio-group>
										</el-form-item>
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='multiple'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<el-form-item>
											<el-checkbox-group @input="forceUpdate" v-if="children_item.choices.length>0" v-model="testForm_universal[children_item.unive_i][children_item.id].answer">
												<el-checkbox v-for="(chObj,ch_index) in children_item.choices" :key="ch_index" :label="chObj.flag" :name="children_item.unive_i+'cho'+ch_index">
													{{chObj.flag}}.
													<img v-if="chObj.img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+chObj.img})" :src="ali_oss+chObj.img">
													{{chObj.content}}
												</el-checkbox>
											</el-checkbox-group>
										</el-form-item>
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='judgement'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<el-form-item>
											<el-radio-group @input="forceUpdate" v-model="testForm_universal[children_item.unive_i][children_item.id].answer[0]">
												<el-radio label="对"></el-radio>
												<el-radio label="错"></el-radio>
											</el-radio-group>
										</el-form-item>
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='fill'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										<!-- 输入框显示 -->
										<div class="input_box">
											<el-form-item v-for="(ch_item,ch_index) in children_item.choices" :key="ch_index+'ch'">
												<el-input @input="forceUpdate" v-model="testForm_universal[children_item.unive_i][children_item.id].answer[ch_index]" autocomplete="off"></el-input>
											</el-form-item>
										</div>
										<!-- 图片选择 -->
										<div class="upload_box">
											<el-upload class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
											:on-change="u_handle_change"
											:on-exceed="handle_exceed"
											:file-list="testForm_universal[children_item.unive_i][children_item.id].answer_img">
												<i slot="default" @click="handProgress(children_item.unive_i, children_item.id)" class="el-icon-plus"></i>
												<div slot="file" slot-scope="{file}">
													<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
													<div class="el-upload-list__item-actions">
														<span @click="handlePictureCardPreview(file)">
															<i class="el-icon-zoom-in"></i>
														</span>
														<span @click="u_handleRemove(file, children_item.unive_i, children_item.id)">
															<i class="el-icon-delete"></i>
														</span>
													</div>
												</div>
											</el-upload>
											<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
										</div> 
									</dl>
								</li>
							</ul>
							<ul :class="children_item.type" v-if="children_item.type=='open'">
								<li :class="'universal'+children_item.unive_i+sub_i">
									<p><font>{{(children_item.universal_sort)}}.</font><span class="title" v-html="children_item.title.replace(/\n/g, '<br>')"></span><span class="score">（{{children_item.score}}分）</span></p>
									<p v-if="children_item.question_img" class="question_img">
										<img :src="ali_oss+children_item.question_img" @click.prevent.stop="handlePictureCardPreview({url:ali_oss+children_item.question_img})">
									</p>
									<dl>
										
										<div class="input_box">
											<el-form-item>
												<el-input @input="forceUpdate" type="textarea" class="open_textarea" v-model="testForm_universal[children_item.unive_i][children_item.id].answer[0]" autocomplete="off"></el-input>
											</el-form-item>
										</div>
										<!-- 图片选择 -->
										<div class="upload_box" v-if="temp.universal.open.up_img">
											<el-upload class="upload_item" action="#" list-type="picture-card" :auto-upload="false" :limit='5'
											:on-change="u_handle_change"
											:on-exceed="handle_exceed"
											:file-list="testForm_universal[children_item.unive_i][children_item.id].answer_img">
												<i slot="default" @click="handProgress(children_item.unive_i, children_item.id)" class="el-icon-plus"></i>
												<div slot="file" slot-scope="{file}">
													<img class="el-upload-list__item-thumbnail" :src="file.url" alt />
													<div class="el-upload-list__item-actions">
														<span @click="handlePictureCardPreview(file)">
															<i class="el-icon-zoom-in"></i>
														</span>
														<span @click="u_handleRemove(file, children_item.unive_i, children_item.id)">
															<i class="el-icon-delete"></i>
														</span>
													</div>
												</div>
											</el-upload>
											<p class="upload_desc">只能上传jpg/jpeg/png文件，且不超过500kb</p>
										</div>
									</dl>
								</li>
							</ul>
						</div>
						
					</div>
				</div>
				<el-button type="primary" class="submitForm" @click="submitForm('testForm')"><i class="iconfont">&#xe651;</i>提交</el-button>
			</el-form>
		</div>
		<div class="timeCalculationBox">
			<div class="camera_outer" v-if="join_kaoshi.is_photograph || join_kaoshi.is_inspection">
				<video v-if="camera" ref="mediaElement" id="videoCamera" autoplay style="width:100%"></video>
				<canvas v-if="camera" style="display:none;" id="canvasCamera"></canvas>
      			<div class="img_bg_camera" style="display:none;">
      			  	<img :src="imgSrc" alt="" class="tx_img">
      			</div>
			</div>
			<div class="timeBox"><i class="iconfont">&#xe6b1;</i>{{timeCal}}</div>
			<div class="timu_scroll">
				<ul>
					<li v-for="(item,index) in formal" :key="index" v-if="item.list && item.list.length >= 1">
						<div v-if="item.type != 'universal'">
							<h2>{{item.headline == "" ? big_qs_tit_txt(item.type) : item.headline}}</h2>
							<dl>
								<dd v-for="(obj,numindex) in testForm[index]" :class="time_cal_class(obj)" :key="numindex" @click="scrollFn(item.type+index+numindex)">{{numindex+1}}</dd>
							</dl>
						</div>
						<div v-else style="margin-top:10px;">
							<h2>{{item.headline == "" ? big_qs_tit_txt('universal') : item.headline}}</h2>
							<dl v-for="(un,un_idx) in item.list" :key="un_idx">
								<dd v-for="(un_obj, un_obj_idx) in un.children" :key="un_obj_idx" :class="time_cal_class(un_obj,'universal')" @click="scrollFn(testForm_universal[un_obj.unive_i][un_obj.id].click_str)">
									{{un_obj.universal_sort}}
								</dd>
							</dl>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<el-dialog
			title="提示"
			:visible.sync="dialogVisible"
			width="30%">
			<span>当前正在考试，是否离开</span>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="pageout">确 定</el-button>
			</div>
		</el-dialog>
		<el-dialog
			class="question_preview"
			title=""
			width="intial"
			:visible.sync="question_preview_visible" center>
			<span slot="footer" class="dialog-footer"><img :src="preview_img_src"></span>
		</el-dialog>
		<el-dialog
			class=""
			title="提示"
			width="400px"
			:before-close="close_blur_test_dialog"
			:show-close="false"
			:visible.sync="blur_test_dialog">
			<span>考试期间禁止切屏，<font color="#f00">{{blur_test_time}}</font>&nbsp;后将自动交卷，请返回考试。</span>
			<div slot="footer" class="dialog-footer">
				<el-button type="danger" @click="close_blur_test_dialog">关闭</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
// import { log } from 'util';
var tnum
const OSS = require('ali-oss');
// const express = require("express");
// const app = express();
// app.get('/sts', (req, res) => {
// 	let sts = new STS({
// 		// 阿里云主账号AccessKey拥有所有API的访问权限，风险很高。强烈建议您创建并使用RAM账号进行API访问或日常运维，请登录RAM控制台创建RAM账号。
// 		accessKeyId: 'LTAI5t9WQNcsH2e7W5Nr78HL',
// 		accessKeySecret: '4FIy6qj1dSDhGy521AxKKkpdcssUYm'
// 	});
// 	sts.assumeRole('acs:ram::1129310106292569:role/ossadmin', 'all').then((result) => {
// 		console.log(result);
// 		res.set('Access-Control-Allow-Origin', '*');
// 		res.set('Access-Control-Allow-METHOD', 'GET');
// 		res.json({
// 			AccessKeyId: result.credentials.AccessKeyId,
// 			AccessKeySecret: result.credentials.AccessKeySecret,
// 			SecurityToken: result.credentials.SecurityToken,
// 			Expiration: result.credentials.Expiration
// 		});
// 	}).catch((err) => {
// 		console.log(err);
// 		res.status(400).json(err.message);
// 	});
// });
import * as rts from 'aliyun-rts-sdk';
let aliRts = rts.AliRTS.createClient()
export default {
	name: 'test'
	,data () {
		tnum=0;
		let formal={
			single:{},
			multiple:{},
			judgement:{},
			fill:{},
			open:{},
			universal:{},
		}
		// 获取抓拍、巡考的缓存数据
		if(localStorage.getItem('join_kaoshi')) this.global.join_kaoshi = JSON.parse(localStorage.getItem('join_kaoshi'))
		return {
			temp: this.temp.course_info.test,
			// 交卷防止多次
			jiaojuandianji:false,
			//拍摄
			join_kaoshi:this.global.join_kaoshi,	//是否渲染拍摄
			// 拍照次数
			photo_len:1,
			// paizhaocishu:'',
			// 拍照时间随机
			// paizhaotime:[],
			imgSrc: '',
        	thisCancas: null,
        	thisContext: null,
        	thisVideo: null,
			camera:true,
			//拍照计时
			photo_time:0,

			// 页面参数
			// protocol:window.location.protocol,
			ali_oss:this.global.oss_link,
			test_load:true,
			location:[{
				title:"我的考试",
				router:"/web/exam_list",
				name: 'exam_list',
				activeIndex: 'exam_list',
				query:{page:'exam_list'},
				show: this.$store.state.template.course_info.test.location.exam_list,
			}],
			//文件上传
			question_preview_visible:false,
			preview_img_src:'',
			upload_img_info:{
				key:'',
				ti_index:'',
			},

			//试题
			test_tit:'',
			test_time:0,
			test_fen:0,
			test_exam:0,
			testForm:{
				single:[],
				multiple:[],
				judgement:[],
				fill:[],
				open:[],
				other1:[],
				other2:[],
				universal:[]
			},
			testForm_universal:[],
			formal:formal,
			timeCal:"0:00:00",

			//页面离开
			tijiaolikai:false,
			dialogVisible:false,
			beforeRouteLeave_next:'',
			leave_type:'',

			// 本地流
			localStream:'',
			//大题排序
			universal_sort:0,
			// universal_sort_arr:[],
			compare_avatars:'',
			use_time:0,			// 考试已用时长 （秒）
			user_answer_cache: '',		// 用户答题记录
			blur_test_dialog: false,	// 失去焦点弹窗提醒
			blur_test_time: '',			// 失焦弹窗倒计时
		}
	}
	,mounted:function(){
		var that=this
			,serverSrc=that.global.serverSrc
			,qianzui=that.global.qianzui

		//判断是否从考试安排页进入
		// if(!this.join_kaoshi.switch){
		// 	this.$alert('请从考试安排进入考试页', '提示', {
		// 		confirmButtonText: '确定',
		// 		closeOnHashChange: false,
		// 		showClose: false,
		// 		callback: action => {
		// 			this.back_courseInfo()
		// 		}
		// 	});
		// 	return false;
		// }

		//启用摄像头
		if(this.join_kaoshi.is_photograph || this.join_kaoshi.is_inspection){
			this.getCompetence({
				is_photograph: this.join_kaoshi.is_photograph,		// 拍照
				is_inspection: this.join_kaoshi.is_inspection,		// 巡考
			})
		}
		
		//修改上一页的网址
		history.pushState(null, null, document.URL);
    	window.addEventListener('popstate', function () {
			if(!that.dialogVisible){
				//修改切换页面的类型
				that.leave_type = 'popstate'
				//显示询问返回的弹窗
				that.dialogVisible = true
				console.log(1);
				//修改上一页的网址
				history.pushState(null, null, document.URL);
			}
    	});
		//初步生成考卷
		this.$ajax.post(
			serverSrc + qianzui + "/exam/create_exam_log",
			this.$qs.stringify({
				test_id: this.$route.query.test_id,
				compare_avatars:this.$route.query.img_url
			})
		)
		.then((res)=>{
			let resData=res.data
			if(resData.code==0){
				this.exam_log_id = resData.data

				// 获取用户答题记录
				this.$ajax.get(serverSrc + qianzui + "/exam/get_user_answer_cache",{
					params: {
						exam_log_id: this.exam_log_id,
					}
				})
				.then((res)=>{
					let resData = res.data
					if(resData.code == 0){
						this.user_answer_cache = resData.data
						this.get_question_info(this.exam_log_id)
					}
				})
				.catch((err)=>{
					console.log(err);
				})
			}else{
				this.$alert(resData.message, '提示', {
					confirmButtonText: '确定',
					closeOnHashChange: false,
					showClose: false,
					callback: action => {
						this.tijiaolikai=true
						this.back_courseInfo()
					}
				});
			}
		})
		// 切换页面弹窗提醒
		window.onblur=()=>{
			if (this.temp.onblur) {
				if(!this.blur_test_dialog){
					let s = 0.5*60
					this.blur_test_inter = setInterval(() => {
						s = s - 1
						let minute = Math.floor( s /60 ); 
						let second = s - minute*60; 
						this.blur_test_time = (minute<10?'0'+minute:minute) + ":" + (second<10?'0'+second:second)
						if(!this.blur_test_dialog) this.blur_test_dialog = true
						if(s == 0){
							// 关闭失焦弹窗
							this.close_blur_test_dialog()
							// 触发交卷
							this.done_exam();
						}
					}, 1000)
				}
			}
			
			
		}
	}
	,methods:{
		get_question_info(log_id){
			let that = this
			//获取试题信息
			let url = this.global.serverSrc + this.global.qianzui + "/exam/question_info/" + this.$route.query.test_id
			this.$ajax.get(url, {
				params: {
					log_id,
				}
			})
			.then((res)=>{
				// console.log(JSON.stringify(res.data.data));
				let resData=res.data
				if(resData.code==0){
					let question_info = resData.data
					let unive_i = 0
					this.test_load = false
					this.test_tit = question_info.test_title
					this.test_time = question_info.exam_duration || 10
					this.timeTotal = this.test_time * 60
					this.max_timeTotal = JSON.parse(JSON.stringify(this.test_time * 60))
					this.test_fen = question_info.max_score || 10
					this.test_exam = question_info.question_total || 30
					this.formal = []
					this.formal = question_info.question
					// 判断该卷是否有缓存记录
					let cache_id = []
					if(this.user_answer_cache){
						// 减去已使用的时间
						this.timeTotal = this.timeTotal - this.user_answer_cache.use_time
						if(this.user_answer_cache.answer &&　this.user_answer_cache.answer){
							// 记录有答案的ID
							this.user_answer_cache.answer.map((item, index, arr)=>{
								cache_id.push(parseInt(item.question_id))
							})
						}
					}
					for (let i = 0; i < question_info.question.length; i++) {
						let tiNnum=question_info.question[i].list.length,
							tiArr=[],
							key = question_info.question[i].type,
							data_obj = question_info.question[i]
						for(let t=0;t<tiNnum;t++){
							let tiId = data_obj.list[t].id,
								tianArr = [],
								tianImgArr = []
							if(key == "fill" || key == "other1" || key == "other2"){
								for(let f=0;f<data_obj.list[t].fill_count;f++){
									tianArr.push("")
								}
							}
							// 添加缓存答案
							if(cache_id.length && cache_id.includes(tiId)){
								let cache_answer = this.user_answer_cache.answer[ cache_id.indexOf(tiId) ]
								if(cache_answer.answer) tianArr = cache_answer.answer
								if(cache_answer.answer_img) tianImgArr = cache_answer.answer_img
							}
							tiArr.push({"question_id":tiId, "answer":tianArr, "answer_img": tianImgArr,type:key})
						}
						this.testForm[i] = tiArr
						if (key == 'universal') {
							for (let j = 0; j < data_obj.list.length; j++) {
								let uni_obj = data_obj.list[j]
								let obj = {}
								// console.log(j);
								// console.log(uni_obj);
								this.universal_sort = 0
								for (let l = 0; l < uni_obj.children.length; l++) {
									this.universal_sort++
									uni_obj.children[l].universal_sort = this.universal_sort
									uni_obj.children[l].unive_i = unive_i
									let tiId = uni_obj.children[l].id,
										key = uni_obj.children[l].type,
										tianArr = [],
										tianImgArr = []
									if(key == "fill" || key == "other1" || key == "other2"){
										for(let f=0;f<uni_obj.children[l].choices.length;f++){
											tianArr.push("")
										}
									}
									// 添加缓存答案
									if(cache_id.length && cache_id.includes(tiId)){
										let cache_answer = this.user_answer_cache.answer[ cache_id.indexOf(tiId) ]
										if(cache_answer.answer) tianArr = cache_answer.answer
										if(cache_answer.answer_img) tianImgArr = cache_answer.answer_img
									}
									obj[tiId] = {
										question_id: tiId,
										answer: tianArr,
										answer_img: tianImgArr,
										universal_sort: this.universal_sort,
										click_str: 'universal'+unive_i+l,
									}
								}
								unive_i++
								this.testForm_universal.push(obj)
							}
						}
					}
					if(tnum<1){
						this.countDown()
						tnum++
					}
					
					let cal=$(".timeCalculationBox"),
						calTop=cal.offset().top,
						calLeft=cal.offset().left
					$(window).scroll(function(){
						if($(document).scrollTop() > 0){
							cal.addClass("pfx").css({
								top:calTop,
								left:calLeft-3
							})
						}else{
							cal.removeClass("pfx").removeAttr("style");
						}
					})
				}else{
					this.$alert(resData.message, '提示', {
						confirmButtonText: '确定',
						closeOnHashChange: false,
						showClose: false,
						callback: action => {
							that.tijiaolikai=true
							that.back_courseInfo()
						}
					});
				}
			})
		},
		handProgress(key, ti_index){
			// console.log('点击添加文件');
			this.upload_img_info = {
				key:key,
				ti_index:ti_index
			}
		},
		handle_change(file, fileList){
			// console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
			// console.log(file, fileList)
			let that = this
				,test_id = this.$route.query.test_id
				,del_file = false
				,key = this.upload_img_info.key
				,ti_index = this.upload_img_info.ti_index
			if(file.raw.type != "image/jpg" && file.raw.type != "image/jpeg" && file.raw.type != "image/png"){
				this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			if(file.size > 512000){
				this.$alert('图片大小不能超过500KB', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			//验证不通过，删除显示的文件
			if(del_file){
				fileList.splice(fileList.length-1, 1)
			}else{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				//验证通过，上传图片
				let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/${that.$md5(new Date().getTime().toString())}.${file.raw.type.split("/")[1]}`;
				this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+test_id}))
		    	.then(res=>{
					let resData = res.data
					if(resData.code==0){
						let oss_data = new FormData()
						oss_data.append("key",upload_path);
 						oss_data.append("policy", resData.data.policy);
 						oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 						oss_data.append("success_action_status", '200');
 						oss_data.append("signature", resData.data.signature);
 						oss_data.append("file", file.raw);
						
						this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
							if (res.ok) {
								that.testForm[key][ti_index].answer_img.push({
									uid:file.uid
									,url:that.global.oss_link + upload_path
									,name:upload_path
									,file_name:file.name
								})
							}else{
								that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
									confirmButtonText: '确定',
								});
								fileList.splice(fileList.length-1, 1)
							}
						})
					}else{
						that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
							confirmButtonText: '确定',
						});
						fileList.splice(fileList.length-1, 1)
						this.$message.error(resData.message)
					}
					loading.close()
		    	}).catch(_ => {
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					fileList.splice(fileList.length-1, 1)
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					loading.close()
				});
				
			}
		},
		u_handle_change(file, fileList){
			// console.log('文件状态改变时的钩子，添加文件、上传成功和上传失败时都会被调用');
			// console.log(file, fileList)
			let that = this
				,test_id = this.$route.query.test_id
				,del_file = false
				,key = this.upload_img_info.key
				,ti_index = this.upload_img_info.ti_index
			if(file.raw.type != "image/jpg" && file.raw.type != "image/jpeg" && file.raw.type != "image/png"){
				this.$alert('只能上传jpg/jpeg/png文件', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			if(file.size > 512000){
				this.$alert('图片大小不能超过500KB', '信息提示', {
					confirmButtonText: '确定'
				})
				del_file = true;
			}
			//验证不通过，删除显示的文件
			if(del_file){
				fileList.splice(fileList.length-1, 1)
			}else{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				//验证通过，上传图片
				let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/${that.$md5(new Date().getTime().toString())}.${file.raw.type.split("/")[1]}`;
				this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+test_id}))
		    	.then(res=>{
					let resData = res.data
					if(resData.code==0){
						let oss_data = new FormData()
						oss_data.append("key",upload_path);
 						oss_data.append("policy", resData.data.policy);
 						oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 						oss_data.append("success_action_status", '200');
 						oss_data.append("signature", resData.data.signature);
 						oss_data.append("file", file.raw);
						
						this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
							// console.log(res);
							if (res.ok) {
								that.testForm_universal[key][ti_index].answer_img.push({
									uid:file.uid
									,url:that.global.oss_link + upload_path
									,name:upload_path
									,file_name:file.name
								})
							}else{
								that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
									confirmButtonText: '确定',
								});
								fileList.splice(fileList.length-1, 1)
							}
						})
					}else{
						that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
							confirmButtonText: '确定',
						});
						fileList.splice(fileList.length-1, 1)
						this.$message.error(resData.message)
					}
					loading.close()
		    	}).catch(_ => {
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
					fileList.splice(fileList.length-1, 1)
					// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
					loading.close()
				});
			}
		},
		handle_exceed(files, fileList){
			// console.log('文件超出个数限制时的钩子');
			this.$alert('最多上传5张图片', '信息提示', {
				confirmButtonText: '确定'
			})
		},
		handleRemove(file, key, ti_index) {
			// console.log('删除了文件');
			let del_idx = -1
				,answer_img = this.testForm[key][ti_index].answer_img
				that = this
			answer_img.forEach(function(item,index){
				if(item.uid == file.uid){
					del_idx = index
				}
			})
			if(del_idx > -1){
				answer_img.splice(del_idx, 1);
			}
		},
		u_handleRemove(file, key, ti_index) {
			// console.log('删除了文件');
			let del_idx = -1
				,answer_img = this.testForm_universal[key][ti_index].answer_img
				that = this
			answer_img.forEach(function(item,index){
				if(item.uid == file.uid){
					del_idx = index
					console.log(item);
				}
			})
			if(del_idx > -1){
				answer_img.splice(del_idx, 1);
			}
		},
		handlePictureCardPreview(file) {
			// console.log(file);
			// console.log('点击了预览按钮')
			this.question_preview_visible = true
			this.preview_img_src = file.url
		},
		//返回到考试页
		back_courseInfo(){
			if(this.localStream){
				// 移除本地流
				this.removeStream("videoCamera")
			}
			// 跳转到考试列表页
			this.$router.push({
				path: this.location[0].router,
				name: this.location[0].name,
				query: this.location[0].query,
				params: ''
			})
		},
		// 调用权限（打开摄像头功能）
      	getCompetence (option) {
			let options = Object.assign({
				is_photograph: 0,
				is_inspection: 0,
			}, option)
			let mediaElement = this.$refs.mediaElement
				,serverSrc=this.global.serverSrc
				,qianzui=this.global.qianzui
				,token=this.$cookies.get("token")
			/**
			 * 获取本地流localStream
			 * @param {Object} config 配置
			 * @param {boolean} config.audio 是否使用音频设备
			 * @param {boolean} config.video 是否使用视频设备
			 * @param {boolean} config.screen 是否使用屏幕捕获
			 * @returns {Promise}
			 */
			rts.AliRTS.createStream({
				audio: options.is_inspection == 1,
				video: true,
				screen: false,
			}).then((localStream) => {
				// 预览推流内容，mediaElement是媒体标签audio或video
				localStream.play(mediaElement);
				this.localStream = localStream
				setTimeout(()=>{
					this.thisCancas = document.getElementById('canvasCamera')
					this.thisCancas.width = $("#videoCamera")[0].videoWidth
					this.thisCancas.height  = $("#videoCamera")[0].videoHeight
					this.thisContext = this.thisCancas.getContext('2d')
					this.thisVideo = document.getElementById('videoCamera')
				},500)
				//巡考
				if(this.join_kaoshi.is_inspection){
					// 打开页面加载状态
					this.test_load = true
					this.$ajax.post(serverSrc + qianzui + "/lives/createByTest",
						this.$qs.stringify({
							test_id: this.$route.query.test_id,
						})
					)
					.then((res)=>{
						let resData = res.data
						if(resData.code == 0){
							this.publish(resData.data.paths[1].path, localStream)
						}else{
							// 解除禁止离开页面状态
							this.tijiaolikai=true
							// 弹窗提示错误信息，点击确定后返回到考试列表页
							this.$alert(resData.message, '提示', {
								confirmButtonText: '确定',
								closeOnHashChange: false,
								showClose: false,
								callback: action => {
									this.back_courseInfo()
								}
							});
						}
					})
				}
			}).catch((err) => {
				// 错误码说明文档：https://help.aliyun.com/document_detail/397571.html
				let message = err.message
				if (err.errorCode==10002) {
					message = '找不到摄像头'
				}
				this.$alert(`创建本地流失败，错误码：${err.errorCode}。${message}`, {
					type: 'error',
					confirmButtonText: '确定'
				})
			})
      	},
		//  绘制图片（拍照功能）
      	setImage () {
      		let that = this
				,test_id = this.$route.query.test_id
      		// 点击，canvas画图
      		this.thisContext.drawImage(this.thisVideo,0 ,0, this.thisCancas.width, this.thisCancas.height, 0, 0, this.thisCancas.width, this.thisCancas.height)
      		// 获取图片base64链接
      		let image = this.thisCancas.toDataURL('image/jpeg',1)
			// 拍照文件的base 64
      		this.imgSrc = image
			let file = this.dataURLtoFile(this.imgSrc,new Date().getTime().toString())
			
			//拍摄完毕，上传图片
			let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${test_id}/photo/${that.$md5(new Date().getTime().toString())}.${file.type.split("/")[1]}`;
			this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",
				this.$qs.stringify({
					dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+test_id+'/photo'
				})
			)
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
					let oss_data = new FormData()
					oss_data.append("key",upload_path);
 					oss_data.append("policy", resData.data.policy);
 					oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 					oss_data.append("success_action_status", '200');
 					oss_data.append("signature", resData.data.signature);
 					oss_data.append("file", file);
					
					this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
						// console.log(res);
						if (res.ok) {
							// 拍照次数+1
							that.photo_len++
							//上传图片路径
							that.$ajax.post(
								that.global.serverSrc+that.global.qianzui+'/exam/save_photo',
								that.$qs.stringify({
									test_id:test_id,
									url:upload_path
								}),
							)
						}else{
							that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
								confirmButtonText: '确定',
							});
						}
					})
				}else{
					that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
						confirmButtonText: '确定',
					});
				}
		    }).catch(_ => {
				that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
					confirmButtonText: '确定',
				});
			});
      	},
		// base64转文件
      	dataURLtoFile (dataurl, filename) {
      	  	var arr = dataurl.split(',')
      	  	var mime = arr[0].match(/:(.*?);/)[1]
      	  	var bstr = atob(arr[1])
      	  	var n = bstr.length
      	  	var u8arr = new Uint8Array(n)
      	  	while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
      	  	}
      	  	return new File([u8arr], filename, { type: mime })
      	},
		//点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//大标题文字输出
		big_qs_tit_txt(t){
			let c;
			switch (t) {
				case "single":
					c="单选题"
					break;
				case "multiple":
					c="多选题"
					break;
				case "judgement":
					c="判断题"
					break;
				case "fill":
					c="填空题"
					break;
				case "open":
					c="主观题"
					break;
				case "other1":
					c="名词解释题"
					break;
				case "other2":
					c="论述分析题"
					break;
				case "universal":
					c="大题"
					break;
			}
			return c;
		},
		exam(option){
			let options = Object.assign({
				before: '',
				success: '',
				error: '',
				cache: 1,
			}, option)
			let url = this.global.serverSrc+this.global.qianzui+'/exam/done_exam/'+this.$route.query.test_id;
			
			this.tijiaolikai=true
			let testForm = this.testForm;
			let testForm_universal = this.testForm_universal
			let anArr=[]
			for(var key in testForm){
				// if (key!='universal') {
					testForm[key].forEach(function(item,index){
						if(item.answer.length != 0 || item.answer_img.length > 0){
							anArr.push(item)
						}
					})	
				// }
			}
			for (let i = 0; i < testForm_universal.length; i++) {
				for (const key in testForm_universal[i]) {
					let item = testForm_universal[i][key]
					if(item.answer.length != 0 || item.answer_img.length > 0){
						anArr.push(item)
					}
				}
				
			}
			console.log(anArr);
			// return false
			//交卷请求
			if(options.before && typeof options.before === 'function') options.before()
			this.$ajax.post(url,
				this.$qs.stringify({
					answer:anArr,
					lave_time:this.timeCal,
					exam_log_id:this.exam_log_id,
					use_time: this.use_time,			// 已用时长 （秒）
					cache: options.cache,							// 是否为缓存 1是 2否
				}),
			)
			.then((res)=>{
				if(options.success && typeof options.success === 'function') options.success(res)
			})
			.catch((err)=>{
				if(options.error && typeof options.error === 'function') options.error(err)
			})
		},
		//交卷函数
		done_exam(){
			let loading
			this.exam({
				cache: 2,
				before:(e)=>{
					this.jiaojuandianji = true
					loading = this.$loading({
						lock: true,
						text: '交卷中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				},
				success:(res)=>{
					loading.close();
					let resData=res.data;
					if(resData.code==0){
						this.jiaojuandianji=false
						if(this.localStream){
							// 停止推流
							this.removeStream("videoCamera")
						}
						//弹出即将退出登录的提示框
						this.$alert('交卷成功，请离开考场！', '信息提示', {
							confirmButtonText: '确定',
							callback: action => {
								//返回考试安排列表页
								this.back_courseInfo()
							}
						});
					}else{
						this.$message.error(resData.message);
						this.jiaojuandianji=false
					}
				},
				error:(err)=>{
					loading.close();
					console.log(err);
					this.$message.error("网络异常");
					this.jiaojuandianji=false
				}
			})
		},
		//点击提交按钮
		submitForm(formName) {
			// this.$message.error('提交失败');
			// return 
			let that=this
			let ble=true
			let testForm=this.testForm
			let testForm_universal = this.testForm_universal
			// console.log(testForm);
			
			for(let key  in testForm){
				for(let i = 0;i<testForm[key].length;i++){
					if (testForm[key][i].type=='universal') {
						delete this.testForm[key][i].type
						break;
					}
					if(testForm[key][i].answer.length==0){
						// console.log('i:'+i);
						
						ble=false
						break;
					}else{
						for(let j = 0;j<testForm[key][i].answer.length;j++){
							if(testForm[key][i].answer[j]==''){
								// console.log('j:'+j);
								ble=false
								break;
							}
						}
					}
				}
  			}
			// console.log(testForm_universal);
			for (let i = 0; i < testForm_universal.length; i++) {
				for (const key in testForm_universal[i]) {
					for (let j = 0; j < testForm_universal[i][key].answer.length; j++) {
						if(testForm_universal[i][key].answer[j]==''){
							// console.log('i:'+i+"j:"+j);
							
							ble=false
							break;
						}
					}
					
				}
			}
			if(ble){
				this.$confirm('是否交卷?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					that.done_exam();
				}).catch((err) => {
					console.log(err);
					//点击取消          
				});
			}else{
				this.$confirm('该试题还没完成，是否继续答题?', '温馨提示', {
					confirmButtonText: '完成交卷',
					cancelButtonText: '继续答卷',
					type: 'warning'
				}).then(() => {
					that.done_exam(); 
				}).catch((err) => {
					console.log(err);
					//点击取消         
					
				});
			}
			
		},
		//考试倒计时
		countDown() {
			let miss = 0	// 缓存丢包次数
			
			let that = this
			// return false
			this.global.pageTimer['examTime'] = window.setInterval(() => {
				let s = this.timeTotal-1
					,photograph_interval = this.join_kaoshi.photograph_interval
					,photo_num_min = this.join_kaoshi.photo_num_min
					,photo_num_max = this.join_kaoshi.photo_num_max
				if(this.join_kaoshi.is_photograph){
					//计时拍照
					this.photo_time++
					//如果时间整除间隔时间 且 拍照次数小于最大拍照数
					if( this.photo_time % photograph_interval == 0 && this.photo_len <= photo_num_max){
						this.setImage()
					}
				}
				// 记录用户考试已用时间
				this.use_time = this.max_timeTotal - s
				// 每隔一段时间保存一次答案
				if(this.use_time % 30 == 0){
					let timeout_cache_exam
					let cache_exam = ()=>{
						this.exam({
							cache: 1,
							success: res=>{
								let resData=res.data;
								if(resData.code != 0){
									this.$message.error(resData.message);
								}
							},
							error: err=>{
								miss = miss + 1
								// 达到两次丢包数则报错及暂停考试计时
								if(miss == 2){
									// 暂停考试倒计时
									clearInterval(this.global.pageTimer['examTime'])
									clearTimeout(timeout_cache_exam)
									this.$confirm('当前网络错误，无法正常进行考试，请联系监考老师！', '温馨提示', {
										confirmButtonText: '确定',
										showCancelButton: false,
										showClose: false,
										type: 'error',
										center: true
									}).then(() => {
										// 重启考试倒计时
										this.countDown()
									})
									return false
								}
								timeout_cache_exam = setTimeout(cache_exam, 10000)
							}
						})
					}
					cache_exam()
				}
				if(s == 0){
					this.timeCal = '0:00:00'
					this.timeTotal = s
					clearTimeout(this.global.pageTimer['examTime'])
					if(this.localStream){
						// 停止推流
						this.removeStream("videoCamera")
					}
					this.$alert('考试时间到，请交卷', '提示', {
						confirmButtonText: '确定',
						closeOnHashChange: false,
						showClose: false,
						callback: action => {
							that.done_exam();
						}
					});
					return false;
				}
				var hour = Math.floor( s / 3600); 
				var minute = Math.floor( (s - hour*3600) /60 ); 
				var second = s - hour*3600 - minute*60; 
				this.timeCal = hour + ":" + (minute<10?'0'+minute:minute) + ":" + (second<10?'0'+second:second)
				this.timeTotal = s
			},1000)
		},
		//页面滚动
		scrollFn(cla){
			$("html,body").animate({
				scrollTop:$('.'+cla).offset().top-100
			})
		},
		//离开页面函数
		pageout(){
			if(this.leave_type == 'beforeRouteLeave'){
				if(this.localStream){
					// 移除本地流
					this.removeStream("videoCamera")
				}

				//执行默认的跳转操作
				this.beforeRouteLeave_next()
			}else if(this.leave_type == 'popstate'){
				this.$message({
					showClose: true,
					message: '再次点击确定将执行返回上一页',
					type: 'warning'
				});
				this.dialogVisible = false
				//点击上一页按钮则返回考试安排列表页
				this.back_courseInfo()
			}
		},
		//推流
		publish(pushUrl,local_stream){
			/**
			 * 开始推流
			 * @param {string} pushUrl 推流地址
			 * @param {Object} localStream 由 createStream 创建的本地流
			 * @param {Object} [config] （可选）自定义配置
			 * @param {string} [config.signalUrl] （可选）信令地址
			 * @return {Promise}
			 */
			aliRts.publish(pushUrl, local_stream).then(() => {
				// 推流成功
				console.log('推流成功')
				// 关闭页面加载状态
				this.test_load = false
			}).catch((err) => {
				// 错误码说明文档：https://help.aliyun.com/document_detail/397571.html
				this.$alert(`错误码：${err.errorCode}。${err.message}`, {
					type: 'error',
					confirmButtonText: '确定',
					callback: action => {
						// 解除禁止离开页面状态
						this.tijiaolikai=true
						// 推流失败
						this.$alert('推流失败，请稍后重试', '提示', {
							confirmButtonText: '确定',
							closeOnHashChange: false,
							showClose: false,
							callback: action => {
								this.back_courseInfo()
							}
						});
					}
				})
			})
		},
		// 移除本地流
		removeStream(camera){
			if(this.localStream){
				// 停止推流
				aliRts.unpublish();
				console.log("停止推流成功");
				// 关闭摄像头
				this.localStream.stop()
				// 清空本地流
				this.localStream = ''
				// 移除本地流
				let mediaElement2 = document.getElementById(camera);
				let stream2 = mediaElement2.srcObject;
				if(!stream2) return false
				let tracks2 = stream2.getTracks();
				tracks2.forEach(function(track) {
					track.stop();
				});
				mediaElement2.srcObject = null;
				console.log("移除本地流成功");
			}
		},
		//悬浮框高亮样式
		time_cal_class(obj,type){
			let cla=''
			if (type=='universal') {
				if(this.testForm_universal[obj.unive_i][obj.id].answer){
					for(var a=0;a<this.testForm_universal[obj.unive_i][obj.id].answer.length;a++){
						if(this.testForm_universal[obj.unive_i][obj.id].answer[a].length>0){
							cla = 'act'
							break;
						}
					}
					if(this.testForm_universal[obj.unive_i][obj.id].answer_img.length>0){
						cla = 'act'
					}
				}
			}else{
				if(obj.answer){
					for(var a=0;a<obj.answer.length;a++){
						if(obj.answer[a].length>0){
							cla = 'act'
							break;
						}
					}
					if(obj.answer_img.length>0){
						cla = 'act'
					}
				}
			}
			
			return cla
			
		},
		// 关闭失焦弹窗
		close_blur_test_dialog(){
			// 关闭倒计时
			clearInterval(this.blur_test_inter)
			// 关闭弹窗
			this.blur_test_dialog = false
		},
		//强制渲染
		forceUpdate(){
			this.$forceUpdate()
		}
	},
	filters:{
		
	},
	computed:{
	},
	beforeDestroy: function(){
		// 移除本地流
		this.removeStream("videoCamera")
		// 删除抓拍、巡考的缓存数据
		localStorage.removeItem("join_kaoshi")
	},
	destroyed:function(){
		clearTimeout(this.global.pageTimer['examTime'])
	},
	//vue切换页面
	beforeRouteLeave(to, form, next){
		// console.log(this.timeTotal);		
		if(this.timeTotal != 0 && this.join_kaoshi.switch && !this.tijiaolikai){
			if(!this.dialogVisible){
				this.leave_type = 'beforeRouteLeave'
				this.dialogVisible = true
				history.pushState(null, null, `/web/#/web/exam_list?`);

				this.beforeRouteLeave_next = next	
			}
		}else{
			next();
		}
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style lang="scss" scoped>
#index{background:#f4f4f4;}
.title{
	display: inline-block;
	max-width: calc(100% - 100px);
    // width: calc(100% - 100px);
    word-wrap: break-word;
}
</style>
<style>
.open_textarea textarea{height:300px;}
#test .el-form-item__content .el-textarea__inner{
	resize: vertical;
}
</style>


// WEBPACK FOOTER //
// src/components/course_info/test.vue